module.exports = __webpack_public_path__ + "assets/imgs/banner.9a8173a8.png";